// §2.6 Timecode. format "smpte" → HH:MM:SS:FF at the asset's frame rate (Workbench);
// "mss" → m:ss.s (Portal and Console). Non-drop-frame counting.
export function formatTimecode(seconds, format = 'mss', fps = 29.97) {
  const s = Math.max(0, Number(seconds) || 0);
  if (format === 'smpte') {
    const base = Math.round(fps);
    const frames = Math.round(s * fps);
    const ff = frames % base;
    const total = Math.floor(frames / base);
    return [Math.floor(total / 3600), Math.floor(total / 60) % 60, total % 60, ff].map(n => String(n).padStart(2, '0')).join(':');
  }
  const m = Math.floor(s / 60);
  return `${m}:${(s - m * 60).toFixed(1).padStart(4, '0')}`;
}

export default function Timecode({ seconds, format = 'mss', fps = 29.97, label }) {
  const text = formatTimecode(seconds, format, fps);
  return <span className="ui ui-tc" aria-label={label ? `${label} ${text}` : undefined}>{text}</span>;
}
